import { CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-icon.css.lit';
import { OutlineFeatherIcon } from '../..//base/outline-feather-icon/outline-feather-icon';

/**
 * Pull the icon list from the feather-icons package in order
 * to create the list of available icons.
 */
export const availableColors = [
  'blue-responsible-darken-1',
  'blue-responsible-darken-2',
  'blue-responsible-main',
  'currentColor',
];

export type IconColors = typeof availableColors[number];

/**
 * The IdbIcon component
 * @element idb-icon
 */
@customElement('idb-icon')
export class IdbIcon extends OutlineFeatherIcon {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * if true, the icon will be displayed as a button with background and border
   */
  @property({ type: Boolean, attribute: 'alt' })
  alt = false;

  /**
   * The actual color of the icon, provided by the SVG stroke.
   * @param color to use for icon
   * @default currentColor
   */
  @property({ type: String, attribute: 'color' })
  color: IconColors = 'currentColor';
}
